import { EMBED_POST_MESSAGE_SECURITY_KEY } from '../constants';
import { EmbedPostMessageEvent } from '../enums';
import { EmbedEventPayloadByEvent } from '../types';

export const postMessageToEmbed = <Event extends EmbedPostMessageEvent>(
    action: Event,
    payload?: EmbedEventPayloadByEvent[Event]
): boolean => {
    try {
        const target = window.parent;
        if (typeof target === 'undefined') return false;
        const message = { action, payload };
        window.parent.postMessage(
            { ...message, source: EMBED_POST_MESSAGE_SECURITY_KEY },
            { targetOrigin: '*' }
        );
        return true;
    } catch (err) {
        return false;
    }
};
